import React from 'react';
import { Box, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SendIcon from '@mui/icons-material/Send';
import AgentAvatar from '../../pages/AgentAvatar';
import { PixelPerson } from '../../pixelPerson';
import {
  MASTER_AGENT_HEADWEAR_ID,
  MASTER_AGENT_PIXEL_COLORS,
} from '../../pixelPerson/pixelPersonUtils';
const PREVIEW_AVATAR_SIZE = 20;
const PREVIEW_TEXT_INDENT = '30px';

function SignupPreviewAgentAvatar({ name, size = PREVIEW_AVATAR_SIZE }) {
  if (name === 'Master Agent') {
    return (
      <PixelPerson
        name={name}
        size={size}
        masterAgent
        headwear={MASTER_AGENT_HEADWEAR_ID}
        {...MASTER_AGENT_PIXEL_COLORS}
      />
    );
  }

  return (
    <AgentAvatar
      name={name}
      forceSprite
      size={size}
      borderRadius="4px"
    />
  );
}

function SignupPreviewUserAvatar({ size = PREVIEW_AVATAR_SIZE }) {
  return (
    <AgentAvatar
      size={size}
      forceAvatar
      borderRadius="4px"
      sx={{ bgcolor: 'text.primary' }}
    >
      Y
    </AgentAvatar>
  );
}

function SignupPreviewMessageRow({
  role,
  content,
  senderName,
  time,
  grouped = false,
}) {
  const isUser = role === 'user';
  const displayName = isUser ? 'You' : senderName || 'Agent';

  if (grouped) {
    return (
      <Box className="signup-demo__message-row signup-demo__message-row--grouped">
        <Box sx={{ pl: PREVIEW_TEXT_INDENT }}>
          <Typography className="signup-demo__message-text">{content}</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box className="signup-demo__message-row">
      <Box className="signup-demo__message-body">
        {isUser ? (
          <SignupPreviewUserAvatar />
        ) : (
          <SignupPreviewAgentAvatar name={displayName} />
        )}
        <Box className="signup-demo__message-content">
          <Box className="signup-demo__message-meta">
            <Typography className="signup-demo__message-sender">{displayName}</Typography>
            {time ? (
              <Typography className="signup-demo__message-time">{time}</Typography>
            ) : null}
          </Box>
          <Typography className="signup-demo__message-text">{content}</Typography>
        </Box>
      </Box>
    </Box>
  );
}

function SignupPreviewComposer() {
  return (
    <Box className="signup-demo__composer-shell">
      <Box className="signup-demo__composer-inner">
        <AddIcon className="signup-demo__composer-icon" />
        <Typography className="signup-demo__composer-placeholder">
          Send a message...
        </Typography>
        <SendIcon className="signup-demo__composer-send" />
      </Box>
    </Box>
  );
}

export function SignupPreviewAgentRow({ name, active = false }) {
  return (
    <div
      className={[
        'signup-demo__agent-row',
        active ? 'signup-demo__agent-row--active' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <SignupPreviewAgentAvatar name={name} size={18} />
      <span className="signup-demo__agent-row-label">{name}</span>
    </div>
  );
}

export default function SignupPreviewChatThread({ messages = [], showComposer = true }) {
  return (
    <div className="signup-demo__chat-thread">
      <div className="signup-demo__chat-messages">
        {messages.map((message, index) => (
          <SignupPreviewMessageRow key={`${message.role}-${index}`} {...message} />
        ))}
      </div>
      {showComposer ? <SignupPreviewComposer /> : null}
    </div>
  );
}

export { SignupPreviewAgentAvatar, SignupPreviewUserAvatar };
